import React from "react";

import { JobDataType } from "../../../../types/apop";

export const ApplyForJobCard = ({
  jobTitle,
  companyName,
  companyLogoUrl,
}: JobDataType) => {
  return (
    <div className="l1-relative l1-w-full l1-rounded-lg l1-border l1-border-border-subtle l1-bg-surface-background l1-p-3">
      <div className="l1-absolute l1-left-1/2 l1-top-0 -l1-translate-x-1/2 -l1-translate-y-1/2 l1-rounded-[30px] l1-bg-state-surface-success-subtle l1-px-2 l1-py-0.5 l1-text-xs l1-font-medium l1-text-content-primary">
        Applying for
      </div>

      <div className="l1-flex l1-w-full l1-gap-2">
        <div className="l1-h-9 l1-w-9 l1-bg-white">
          <img
            src={
              companyLogoUrl ??
              "//media.foundit.in/trex/search/public/images/companyLogoDefault.png"
            }
            alt={companyName}
            className="l1-h-full l1-w-full l1-object-contain"
          />
        </div>
        <div className="l1-flex l1-flex-col l1-gap-0.5">
          <h4 className="l1-text-sm l1-font-bold l1-text-content-primary">
            {jobTitle}
          </h4>
          <p className="l1-text-xs l1-text-content-secondary">{companyName}</p>
        </div>
      </div>
    </div>
  );
};
